/**
 * Token storage backed by localStorage under a single namespaced key.
 * The XSS tradeoff is documented in the auth design — bearer-on-Authorization
 * was chosen over httpOnly cookies for Playwright control. The strict CSP
 * at the edge closes the main XSS escalation paths.
 */
export interface TokenPair {
  access: string;
  refresh: string;
}

const KEY = "rp.auth";

export function saveTokens(pair: TokenPair): void {
  localStorage.setItem(KEY, JSON.stringify(pair));
}

export function loadTokens(): TokenPair | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<TokenPair>;
    if (typeof parsed.access !== "string" || typeof parsed.refresh !== "string") return null;
    return { access: parsed.access, refresh: parsed.refresh };
  } catch {
    return null;
  }
}

export function clearTokens(): void {
  localStorage.removeItem(KEY);
}
